const {
  defaultLocale,
  getDomainsForEnv,
  supportedLocales,
  generateFallbackLng,
  hubTranslations,
  hubLocalizations,
  localizeTranslations,
} = require('@icommerce/i18n');
const { cleanEnv, str } = require('envalid');

const env = cleanEnv(process.env, {
  ENV_NAME: str({ default: 'local', choices: ['local', 'black', 'white', 'orange'] }),
});

const localizedTranslations = localizeTranslations(hubTranslations, hubLocalizations);

// eslint-disable-next-line import/no-default-export
module.exports = {
  resources: localizedTranslations,
  localePath: null,
  fallbackNS: 'common',
  fallbackLng: generateFallbackLng(supportedLocales),
  i18n: {
    localeDetection: false,
    defaultLocale,
    locales: supportedLocales,
    domains: getDomainsForEnv(env.ENV_NAME),
  },
};
